import { FormControl, FormControlProps, FormHelperText } from '@mui/material';
import InputBase, { InputBaseProps } from '@mui/material/InputBase';
import Typography, { TypographyProps } from '@mui/material/Typography';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { useController } from 'react-hook-form';
import { IncField } from '../fields.types';

export type EditableTypographyFieldProps = IncField<
  TypographyProps & InputBaseProps & { FormControlProps?: FormControlProps }
>;

/**
 * Displaying like a `Typography`. But acting as an `input`
 */
export const EditableTypographyField = ({
  FormControlProps = {},
  helperText,
  'data-testid': dataTestId = 'EditableTypographyField',
  ...props
}: EditableTypographyFieldProps) => {
  const controller = useController({ name: props.name });

  return (
    <FormControl
      error={!!controller.fieldState.error}
      {...FormControlProps}
      data-testid={dataTestId}
    >
      <Typography
        {...props}
        {...controller.field}
        children={props.value?.toString()}
        component={InputBase}
        aria-describedby={`${props.name}-helpertext`}
        sx={theme => ({
          border: controller.fieldState.error
            ? `1px solid ${theme.palette.error.main}`
            : '1px solid transparent',
          borderRadius: 1,
          px: 1,
          '&:hover': {
            border: controller.fieldState.error
              ? `1px solid ${theme.palette.error.main}`
              : `1px solid ${theme.palette.action.active}`,
          },
          backgroundColor: 'transparent',
        })}
      />
      <FormHelperText id={`${props.name}-helpertext`}>
        <IncFormHelperText
          error={controller.fieldState.error}
          helperText={helperText}
        />
      </FormHelperText>
    </FormControl>
  );
};

export default EditableTypographyField;
